import { WorkshopService } from 'api-new/generated';
import { QueryError } from 'features/shared/model';
import { UseQueryOptions, useQuery } from 'react-query';

export const workshopLaboursQueryKey = 'WorkshopLaboursQueryKey';

export interface WorkshopLaboursInput {
  soHeaderId?: number;
  scheduleDate?: string;
}

export const useWorkshopLaboursQuery = <TQueryKey extends Array<unknown> = unknown[]>(
  input?: WorkshopLaboursInput,
  queryKey?: TQueryKey,
  options?: Omit<
    UseQueryOptions<
      Awaited<ReturnType<typeof WorkshopService.getWorkshopLabourLines>>,
      QueryError,
      Awaited<ReturnType<typeof WorkshopService.getWorkshopLabourLines>>,
      unknown[]
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >
) =>
  useQuery(
    [workshopLaboursQueryKey, ...(queryKey ?? []), input],
    () => WorkshopService.getWorkshopLabourLines(input?.soHeaderId, input?.scheduleDate),
    options
  );
